import { Input } from 'antd'
import CIMSFormItem from 'components/CIMSFormItem'
import { googleSheetFormItemName } from '../../../utils'
import { HelpMessage } from 'utils/constants'
import CIMSSection from 'components/CIMSSection'
import { googleSheetURLFormat } from '@cims-online/shared'

/**
 * unfortunately this is so buried in the CIMSTable infra, that we can't readily
 * get access to the form attached to the modal, which means we can't watch user
 * input to do things, or set form values programmatically for the user, i.e. with a
 * "Set Document ID and Sheet ID with URL" button, without _radically_ changing
 * the edit mutation settings
 *
 * double unfortunately... the custom validator will only run when someone tries
 * to click Ok, not Cancel
 *
 * fortunately... I've made it super clear throughout the app when a Google Sheet
 * connection might have an issue and if the issue is because the document id is
 * bad, or a URL, the error message will tell them something is wrong with the
 * document id
 */
const EditGoogleSheetBody: React.VFC = () => {
  const help = HelpMessage.PayItems.Manage.Connections.GoogleSheet
  return (
    <CIMSSection title="Google Sheet">
      <CIMSFormItem
        help={help.PayItemColumnKey}
        label="Pay Item Column Key"
        name={googleSheetFormItemName('payItemColumnKey')}
        requiredMessage="Please enter a pay item column key"
      >
        <Input allowClear />
      </CIMSFormItem>
      <CIMSFormItem
        help={help.DocumentId}
        label="Document ID"
        name={googleSheetFormItemName('documentId')}
        requiredMessage="Please enter a document ID"
        customValidator={{
          message: `Document ID is extracted from a Google Sheet URL: ${googleSheetURLFormat}`,
          validator: (value: string) => !URL.canParse(value),
        }}
      >
        <Input allowClear />
      </CIMSFormItem>
      <CIMSFormItem
        help={help.SheetId}
        label="Sheet ID"
        name={googleSheetFormItemName('sheetId')}
        requiredMessage="Please enter a sheet ID"
        customValidator={{
          message: `Sheet ID is extracted from a Google Sheet URL: ${googleSheetURLFormat}`,
          validator: (value: string) => !URL.canParse(value),
        }}
      >
        <Input allowClear />
      </CIMSFormItem>
    </CIMSSection>
  )
}

export default EditGoogleSheetBody
